import React from 'react';
import LoadingSpinner from '@cvent/carina/components/LoadingSpinner';
import { injectTestId } from '@cvent/nucleus-test-automation';

/**
 * Simple loading state for full page content
 */
export default function LoadingContent(): JSX.Element {
  return <LoadingSpinner {...injectTestId('page-loading-spinner')} size="l" />;
}
